import { createContext, createElement, useContext, } from "react";
export const createDefaultPropsContext = () => {
    const context = createContext({});
    const Provider = (props) => {
        const { children, ...restProps } = props;
        return createElement(context.Provider, { value: restProps }, children);
    };
    const merge = (props) => {
        const contextProps = useContext(context);
        return {
            ...contextProps,
            ...props,
        };
    };
    const useProps = () => useContext(context);
    return {
        Provider,
        merge,
        useProps,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlRGVmYXVsdFByb3BzQ29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvY3JlYXRlRGVmYXVsdFByb3BzQ29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ0wsYUFBYSxFQUNiLGFBQWEsRUFHYixVQUFVLEdBQ1gsTUFBTSxPQUFPLENBQUM7QUFlZixNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxHQUVBLEVBQUU7SUFDekMsTUFBTSxPQUFPLEdBQUcsYUFBYSxDQUFrQixFQUFFLENBQUMsQ0FBQztJQUVuRCxNQUFNLFFBQVEsR0FBMEQsQ0FDdEUsS0FBSyxFQUNMLEVBQUU7UUFDRixNQUFNLEVBQUUsUUFBUSxFQUFFLEdBQUcsU0FBUyxFQUFFLEdBQUcsS0FBSyxDQUFDO1FBRXpDLE9BQU8sYUFBYSxDQUNsQixPQUFPLENBQUMsUUFBUSxFQUNoQixFQUFFLEtBQUssRUFBRSxTQUE0QixFQUFFLEVBQ3ZDLFFBQVEsQ0FDVCxDQUFDO0lBQ0osQ0FBQyxDQUFDO0lBRUYsTUFBTSxLQUFLLEdBQUcsQ0FBQyxLQUFhLEVBQVUsRUFBRTtRQUN0QyxNQUFNLFlBQVksR0FBRyxVQUFVLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDekMsT0FBTztZQUNMLEdBQUcsWUFBWTtZQUNmLEdBQUcsS0FBSztTQUNULENBQUM7SUFDSixDQUFDLENBQUM7SUFFRixNQUFNLFFBQVEsR0FBRyxHQUFvQixFQUFFLENBQUMsVUFBVSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBRTVELE9BQU87UUFDTCxRQUFRO1FBQ1IsS0FBSztRQUNMLFFBQVE7S0FDVCxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=